import { ReactComponent as ResetSvg } from "./cancel.svg";
const ResetIcon = (props) => {
  return <ResetSvg {...props} />;
};
export default ResetIcon;
